import { Badge, Drawer } from "antd";
import { CheckSquareOutlined, MenuOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";
import { useT } from "../../i18n";
import { UserInfo } from "../../components/molecules";
import { ModelsMenu } from "./ModelsMenu";
import { useTasksModelPath } from "./navigation";
import { useTasksStats } from "./useTasksStats";

const navButtonStyle: React.CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  border: "none",
  background: "transparent",
  fontSize: 10,
  color: "#6b6b66",
  cursor: "pointer",
  padding: "6px 0 10px",
};

// Mobile navigation: bottom bar with a menu drawer and a tasks shortcut
// (with the attention counter). Desktop uses AppSidebar instead.
export const BottomNav: React.FC<{ refetch: any }> = ({ refetch }) => {
  const t = useT();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const user: any = queryClient.getQueryData(["/current-user"]);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const tasksPath = useTasksModelPath();
  const { total } = useTasksStats();

  return (
    <>
      <nav
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          height: 58,
          background: "#fff",
          borderTop: "1px solid #e8e8e6",
          display: "flex",
          zIndex: 1000,
        }}
      >
        <button
          type="button"
          style={navButtonStyle}
          onClick={() => setDrawerOpen(true)}
        >
          <MenuOutlined style={{ fontSize: 17 }} />
          <span>{t("nav.menu")}</span>
        </button>
        {tasksPath && (
          <button
            type="button"
            style={navButtonStyle}
            onClick={() => navigate(tasksPath)}
          >
            <Badge count={total} size="small">
              <CheckSquareOutlined style={{ fontSize: 17 }} />
            </Badge>
            <span>{t("nav.tasks")}</span>
          </button>
        )}
      </nav>

      <Drawer
        placement="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        width={280}
        bodyStyle={{ padding: 0, display: "flex", flexDirection: "column" }}
      >
        {user?.company_logo && (
          <img
            src={user.company_logo}
            alt=""
            style={{ width: "60%", margin: "16px auto" }}
          />
        )}
        <div style={{ flex: 1, overflow: "auto" }}>
          <ModelsMenu onNavigate={() => setDrawerOpen(false)} />
        </div>
        <UserInfo refetch={refetch} />
      </Drawer>
    </>
  );
};
